import { render, staticRenderFns } from "./salaryPayDetail.vue?vue&type=template&id=7fe58640&scoped=true"
import script from "./salaryPayDetail.vue?vue&type=script&lang=js"
export * from "./salaryPayDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe58640",
  null
  
)

export default component.exports